<template>
  <div class="raffle">
    <el-row>
      <el-col style="width: 200px; margin-right: 20px;">
        <el-input v-model="params.order_no" placeholder="订单号"></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px;">
        <el-input v-model="params.user_id" placeholder="用户ID"></el-input>
      </el-col>
			<el-col style="width: 200px; margin-right: 20px;">
        <el-input v-model="params.user_tag" placeholder="用户标签"></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px;">
        <el-input v-model="params.box_id" placeholder="盒子ID"></el-input>
      </el-col>
      <el-col style="width: 220px; margin-right: 20px;">
        <el-date-picker
          v-model="params.created_at_start"
          type="datetime"
          placeholder="开始日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </el-col>
      <el-col style="width: 220px; margin-right: 20px;">
        <el-date-picker
          v-model="params.created_at_end"
          type="datetime"
          placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </el-col>
      <el-col style="width: 90px;">
        <el-button size="small" type="primary" @click="getTableData" icon="el-icon-search"
          >搜索</el-button
        >
      </el-col>
      <el-col style="width: 80px;">
        <el-button style="margin-right: 20px;" @click="handleExport"
          >导出</el-button
        >
      </el-col>
    </el-row>
    <el-table :data="dataList" v-loading="loading" @sort-change="handleSort">
      <el-table-column prop="order_no" label="订单号"></el-table-column>
      <el-table-column prop="box" label="盒子" width="250">
        <template slot-scope="{ row }">
          <div class="box-item">
            <img class="box-image" :src="row.box.image" alt="" />
            <div class="box-name">
              <p>{{ row.box.name }}</p>
              <p style="font-weight: 700;">
                <img class="diamond" style="vertical-align:middle;width:16px" src="../../assets/img/diamond-icon.png" />
                {{ row.box.price }}</p>
              <p>{{ getCategoryName(row.category_id) }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户">
        <template slot-scope="{ row }" v-if="row.user">
          <div class="user-avatar">
            <img :src="row.user.avatar || '/images/default-avatar.jpg'" alt />
            <span>{{ row.user.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user.user_tag" label="用户标签"></el-table-column>
      <el-table-column prop="buy_number" label="购买数量"></el-table-column>
      <el-table-column
        prop="price"
        label="购买价格"
        sortable="costom"
      ></el-table-column>
      <el-table-column
        prop="updated_at"
        label="购买时间"
        sortable="costom"
      ></el-table-column>
			<el-table-column label="福袋奖励" width="250">
				<template slot-scope="{ row }">
					<div class="box-item">
						<img class="box-image" :src="row.prize.image" alt="" />
						<div class="box-name">
							<p>{{ row.prize.name }}</p>
							<p style="font-weight: 700;">
                <img class="diamond" style="vertical-align:middle;width:16px" src="../../assets/img/diamond-icon.png" />
                {{ row.prize.price }}</p>
							<p>
								<span :style="`color: ${getRankColor(row.prize.rank)};`">{{
                getRank(row.prize.rank)
              }}</span>
							</p>
						</div>
					</div>
				</template>
			</el-table-column>
<!--      <el-table-column label="操作">-->
<!--        <template slot-scope="{ row }">-->
<!--          <el-button @click="handleCheckDetail(row.id)">查看抽中奖品</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="dataMeta.current_page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
    <el-dialog :visible.sync="visibleDetail" title="抽中奖品">
      <div v-loading="detailLoading">
        <ul class="prize-list">
          <li
            v-for="(item, index) in flatPrizeList"
            :key="index"
            class="prize-item"
          >
            <img :src="item.prize.image" alt />
            <p>
              <span>{{ item.prize.name }}</span>
            </p>
            <p>
              <span>{{ item.prize.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(item.prize.rank)};`">{{
                getRank(item.prize.rank)
              }}</span>
              <span class="price">
                <img class="diamond" style="vertical-align:middle;width:16px" src="../../assets/img/diamond-icon.png" />
                {{ item.prize.price }}</span>
            </p>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import http, { getData, server } from '../../http'
import saveFile from '../../utils/saveFile'
import ranks from '../../utils/ranks'
export default {
  data() {
    this.ranks = ranks

    return {
      loading: false,
      dataList: undefined,
      dataMeta: {},
      visibleDetail: false,
      detailLoading: false,
      prizeList: [],
      params: {
        page: 1,
        user_id: undefined,
        order_no: undefined,
        order: '',
        order_type: '',
				user_tag: '',
        box_id: undefined,
        created_at_start: undefined,
        created_at_end: undefined
      }
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    }),
    flatPrizeList() {
      if (!this.prizeList || this.prizeList.length === 0) {
        return []
      } else {
        let arr = []
        this.prizeList.forEach(item => {
          for (let i = 0; i < item.number; i++) {
            arr.push(item)
          }
        })
        return arr
      }
    }
  },
  methods: {
    ...mapActions(['getCategories']),
    getRank(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getTableData() {
      this.loading = true
      getData('prize_order', this.params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    handlePageChange(page) {
      this.params.page = page
      this.getTableData()
    },
    handleCheckDetail(id) {
      this.visibleDetail = true
      this.getPrizeList(id)
    },
    getPrizeList(id) {
      this.detailLoading = true
      getData(`prize_order_item/${id}`)
        .then(res => {
          this.prizeList = res.data
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    handleSort(column) {
      this.params.order = column.prop
      this.params.order_type = column.order === 'ascending' ? 'asc' : 'desc'
      this.params.page = 1
      this.getTableData()
    },
    handleExport() {
      http
        .post(
          server + 'prize_order_export',
          { ...this.params, page: undefined },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '抽奖订单记录.xlsx'
          })
        })
    }
  },
  created() {
    this.getTableData()
    !this.categories && this.getCategories()
  }
}
</script>

<style>
</style>
